import React from "react";

const FileTypeCard = ({ Icon, title, description, openFileUploadModal }) => {
  return (
    <div className="filetype-card" onClick={openFileUploadModal}>
      <div className="icon-container">
        <Icon />
      </div>
      <div className="flex flex-column gap-1">
        <p className="title">{title}</p>
        <p className="description">{description}</p>
      </div>
    </div>
  );
};

export default FileTypeCard;
